export const attendanceEmployeeReport = 'reports/attendance-employee/attendanceEmployeeReport'
export const attendanceStudentReportClass = 'reports/attendance-employee/attendanceClassReport'
export const individualattendanceStudentReportClass = 'reports/attendance-employee/individualattendanceStudentReportClass'
export const stdFunditnReport = 'reports/attendance-employee/sutdent-funding-report'
export const YearlyFinancialReport = 'admission-management/admission-fee/report'
export const ParentalTrainingReport = 'student-management/parent-training/report'
export const TeacherTrainingReport = 'student-management/teacher-training/report'
export const eventReport = 'reports/institute-management/event-report'
export const budgetAllocationReport = 'reports/institute-management/budget-allocation-report'
export const transportationReport = 'reports/institute-management/transportation-report'
export const requestFormReport = 'reports/institute-management/request-form-report'
export const assignEmployeeReport = 'reports/institute-management/assign-employee-report'

// registered-student-report
export const registeredStudentReportApi = 'reports/registered-student-report/list'
export const registeredStudentDetailsApi = 'reports/registered-student-report/details'
